import React from "react";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import classes from "./Notification.module.css";
import { getTime, isRecentNotification } from "./notificationutils";
import { withTranslation } from "react-i18next";

class ConferenceLinkNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationtime: "Just Now",
      isNew: false,
    };
  }

  componentDidMount() {
    this.setState({ notificationtime: getTime(this.props.info.createdAt) });
    this.setState({ isNew: isRecentNotification(this.props.info.createdAt) });
  }

  goToConferenceLink = () => {
    const parsedInfo = JSON.parse(this.props.info.postObj);
    let info = {
      meetingLink: parsedInfo.meetingLink ? parsedInfo.meetingLink : "",
      password: parsedInfo.password ? parsedInfo.password : "",
    };
    window.open(info.meetingLink);
  };

  render() {
    const { t } = this.props;
    const parsedPostObj = JSON.parse(this.props.info.postObj);
    return (
      <div className={classes.MesGrid}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-start"
          wrap="nowrap"
        >
          <div
            className={
              this.state.isNew
                ? classes.newNotificationMesHeader
                : classes.notificationMesHeader
            }
          >
            {this.props.info.title}
          </div>
          <div
            className={
              this.state.isNew
                ? classes.newNotificationDateMesHeader
                : classes.notificationDateMesHeader
            }
          >
            {this.state.notificationtime}
          </div>
        </Grid>
        <div
          className={classes.notificationMes}
          onClick={this.goToConferenceLink}
        >
          <b>{parsedPostObj.teacherName}</b> is taking a live class.{" "}
          <b>JOIN NOW</b>
          {parsedPostObj &&
          parsedPostObj.password &&
          parsedPostObj.password != "" ? (
            <p>(password : {parsedPostObj.password})</p>
          ) : (
            ""
          )}
        </div>
        <div
          className={
            this.state.isNew ? classes.NewMesDivider : classes.MesDivider
          }
        />
      </div>
    );
  }
}

export default withTranslation()(ConferenceLinkNotification);
